export default __webpack_public_path__ + "static/media/exeltis_grey.2497a48f.svg";